import {
  BackTitle,
  EditIcon,
  FirstTitle,
  FrontTitle,
} from '@/src/components/EditableTable/EditableTable';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  TableInput,
  //TableSelect,
  // TableNumberInput,
} from 'src/components/EditableTable/TableForm/TableForm';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import Pricing from '../../Components/Pricing/Pricing';
import {
  getSetAndDefaultPrice,
  setAdvancedPrice,
  setAdvancedPriceAddNew,
  setAdvancedPriceExpand,
  setAdvancedPriceSettingsOpen,
  setAdvancedPriceSubProduct,
  setPrice,
} from '../slice';
import ExpandTable from './ExpandTable';
import css from './css.less';
//import { EnumMode } from 'src/components/Antd/NumberInput/NumberInput';
import { getCurrencies } from '@/src/constrains/GlobalProvider/slice';
import { useI18n } from 'src/hooks/useRouterChange';
// import { isNumber } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { EnumTablePosition } from 'src/types/common/common';
import { EnumProductType } from 'src/types/common/product';
import { priceCompare } from '../tools';
import { sum, get } from 'lodash';
const PricingSection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { productUuid, disabled } = props;
  const priceSettings = useSelector(
    (state: any) => state.productSet.priceSettings,
  );

  const { productSetItems, defaultSalePrice } = useSelector(
    getSetAndDefaultPrice(),
  );
  //const products = useSelector((state) => state.productSet.products);
  const name = useSelector((state: any) => state.productSet.productInfo.name);
  const currencies = useSelector(getCurrencies());
  const advancedPriceSettings = useSelector(
    (state: any) => state.productSet.advancedPriceSettings,
  );

  const advancedPriceSettingsOpen = useSelector(
    (state: any) => state.productSet.advancedPriceSettingsOpen,
  );
  const dispatch = useDispatch();
  const priceSettingsOnChange = (data) => {
    dispatch(setPrice(data));
  };
  const advancedPriceSettingsOnChange = (isDelete, index, settings) => {
    dispatch(
      setAdvancedPrice({
        isDelete,
        index,
        settings,
      }),
    );
  };
  const advancedPriceSettingsAddNew = () => {
    dispatch(setAdvancedPriceAddNew());
  };
  const advancedPriceSettingsColOpen = () => {
    dispatch(setAdvancedPriceSettingsOpen());
  };
  const advancedOnChange = (index, setting) => {
    if (advancedPriceSettingsOnChange)
      advancedPriceSettingsOnChange(false, index, setting);
  };
  const advancedSubItemsOnChange = (parentIndex, index, item) => {
    dispatch(setAdvancedPriceSubProduct({ parentIndex, index, item }));
  };
  const openKeys = React.useMemo(() => {
    return advancedPriceSettings.reduce((pre, now) => {
      if (now.open) {
        return [...pre, now.key];
      } else {
        return pre;
      }
    }, []);
  }, [advancedPriceSettings]);

  const columns = React.useMemo(() => {
    return [
      {
        title: () => <React.Fragment />,
        key: 'index',
        childGenerate: (text, record, index) => {
          return <span>{index + 1}</span>;
        },
        width: 40,
        default: true,
      },
      {
        title: () => (
          <FirstTitle>
            <span>
              {getI18n(
                'allProducts.addproductset.pricing_ProductionSetPricingSection_price_Tier',
              )}
            </span>
          </FirstTitle>
        ),
        key: 'title',
        childGenerate: (text, record, index) => {
          const { title = '-' } = record;
          return (
            <NoWrapContainer>
              <Tooltip title={title}>{title}</Tooltip>
            </NoWrapContainer>
          );
        },
        minWidth: 160,

        default: true,
      },
      {
        title: () => (
          <FrontTitle>
            <span>
              {getI18n(
                'allProducts.addproductset.pricing_ProductionSetPricingSection_Items',
              )}
            </span>
          </FrontTitle>
        ),

        childGenerate: (text, record, index) => {
          return (
            <NoWrapContainer>
              <Tooltip title={name}>{name}</Tooltip>
            </NoWrapContainer>
          );
        },
        key: 'price',
        minWidth: 315,

        default: true,
      },
      {
        title: () => (
          <BackTitle>
            <span>
              {getI18n(
                'allProducts.addproductset.pricing_ProductionSetPricingSection_No_of_unit',
              )}
            </span>
          </BackTitle>
        ),

        childGenerate: (text, record, index) => {
          return (
            <BackTitle>
              <React.Fragment />
            </BackTitle>
          );
        },
        key: 'noOfUnit',
        minWidth: 100,
        default: true,
        percentage: 9,
      },
      {
        title: () => (
          <BackTitle>
            <EditIcon />
            <span>
              {getI18n(
                'allProducts.addproductset.pricing_ProductionSetPricingSection_Unit_Price',
              )}
            </span>
          </BackTitle>
        ),
        position: EnumTablePosition.right,

        childGenerate: (text, record, index) => {
          return <React.Fragment />;
        },
        key: 'unitPrice',
        minWidth: 100,
        default: true,
      },
      {
        title: () => (
          <BackTitle>
            <EditIcon />
            <span>
              {getI18n(
                'allProducts.addproductset.pricing_ProductionSetPricingSection_Set_Price',
              )}
            </span>
          </BackTitle>
        ),
        position: EnumTablePosition.right,
        childGenerate: (text, record, index) => {
          console.log('record', record);
          const {
            // setPrice, setPriceError,
            items = [],
          } = record;
          let price = 0;
          items.forEach((i) => {
            const unitPrice = get(i, 'unitPrice');
            const noOfUnit = get(i, 'noOfUnit') || 0;
            price = sum([price, unitPrice * noOfUnit]);
          });

          return (
            <span>{price.toFixed(2)}</span>
            // <TableNumberInput
            //   disabled={disabled}
            //   error={setPriceError}
            //   rightPosition
            //   label={isNumber(setPrice) ? setPrice.toFixed(2) : '-'}
            //   precision={2}
            //   value={price}
            //   onChange={(e) => {
            //     //advancedOnChange(index, { setPrice: e });
            //   }}
            // />
          );
        },
        key: 'setPrice',
        minWidth: 100,
        default: true,
        percentage: 9,
      },
      {
        title: () => (
          <BackTitle>
            <span>
              {getI18n(
                'allProducts.addproductset.pricing_ProductionSetPricingSection_Currency',
              )}
            </span>
          </BackTitle>
        ),
        position: EnumTablePosition.right,
        childGenerate: (text, record, index) => {
          const { currencyCode = '-' } = record;
          return (
            <NoWrapContainer>
              <Tooltip title={currencyCode}>{currencyCode}</Tooltip>
            </NoWrapContainer>
          );
        },
        key: 'currency',
        minWidth: 100,
        default: true,
      },
      {
        title: () => (
          <FrontTitle>
            <EditIcon />
            <span>
              {getI18n(
                'allProducts.addproductset.pricing_ProductionSetPricingSection_Currency',
              )}
            </span>
          </FrontTitle>
        ),

        childGenerate: (text, record, index) => {
          const { notes, notesError } = record;
          return (
            <TableInput
              disabled={disabled}
              maxLength={500}
              error={notesError}
              value={notes}
              onChange={(e) => {
                advancedOnChange(index, { notes: e });
              }}
            />
          );
        },
        key: 'notes',
        minWidth: 100,
        default: true,

        expandRender: (item) => {
          return <div className={css.generalWidth} key='notes'></div>;
        },
      },
    ];
  }, [advancedPriceSettings, currencies, name, disabled]);

  const advancedPricingExpandFunction = {
    expandedRowRender: (record, index, ...rest) => {
      const { items = [], key } = record || {};
      if (items && items.length > 0) {
        return (
          <ExpandTable
            data={items}
            keyProps={key}
            parentIndex={index}
            onChange={advancedSubItemsOnChange}
          />
        );
      }
      return (
        <div>
          {getI18n(
            'allProducts.addproductset.pricing_ProductionSetPricingSection_No_Product',
          )}
        </div>
      );
    },
    rowExpandable: () => {
      return true;
    },
    expandedRowClassName: () => {
      return css.rowExpandContainer;
    },
    expandIcon: ({ expanded, onExpand, record }) =>
      expanded ? (
        <DownOutlined onClick={(e) => onExpand(record, e)} />
      ) : (
        <UpOutlined onClick={(e) => onExpand(record, e)} />
      ),
  };
  const tableProps = {
    rowClassName: (record, index) => {
      if (record.open) {
        return css.noBorderBottom;
      }
    },
    expandable: advancedPricingExpandFunction,
  };
  const expandOnChange = (rows) => {
    dispatch(setAdvancedPriceExpand(rows));
  };

  const defaultSalePriceMismatchError = React.useMemo(() => {
    return !priceCompare(productSetItems, defaultSalePrice);
  }, [productSetItems, defaultSalePrice]);

  return (
    <Pricing
      disabled={disabled}
      productUuid={productUuid}
      type={EnumProductType.Set}
      columns={columns}
      priceSettings={priceSettings}
      advancedPriceSettings={advancedPriceSettings}
      priceSettingsOnChange={priceSettingsOnChange}
      advancedPriceSettingsOnChange={advancedPriceSettingsOnChange}
      advancedPriceSettingsAddNew={advancedPriceSettingsAddNew}
      advancedPriceSettingsOpen={advancedPriceSettingsOpen}
      setAdvancedPriceSettingsOpen={advancedPriceSettingsColOpen}
      tableProps={tableProps}
      onExpandedRowsChange={expandOnChange}
      expandedRowKeys={openKeys}
      defaultSalePriceMismatchError={{
        error: defaultSalePriceMismatchError,
        help: getI18n(
          'allProducts.addproductset.pricing_ProductionSetPricingSection_price_doesnt_match',
        ),
      }}
      //expandIcon={() => <DownOutlined />}
    />
  );
};
export default PricingSection;
